import "./Features.css";
import paymentImage from "../assets/payment.jpeg";
import sportsbookImage from "../assets/sportsbook.png";
import lotteryImage from "../assets/lottery.png";

export interface FeaturesConfig {
  items: Array<{
    id: string;
    title: string;
    description: string;
    imageUrl?: string;
  }>;
}

interface FeaturesProps {
  config?: FeaturesConfig;
}

export default function Features({ config }: FeaturesProps) {
  if (!config || !config.items || config.items.length === 0) {
    return null;
  }

  const getDefaultImage = (id: string): string => {
    switch (id) {
      case "configure-payments":
        return paymentImage;
      case "design-your-brand":
        return sportsbookImage;
      case "launch-globally":
        return lotteryImage;
      default:
        return "";
    }
  };

  const getImageSrc = (item: FeaturesConfig["items"][0]): string => {
    if (item.imageUrl) {
      // If imageUrl is already a full URL, use it as is
      if (item.imageUrl.startsWith("http")) {
        return item.imageUrl;
      }
      // If imageUrl is a relative path, prepend the base URL
      const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8080";
      return `${apiUrl}${item.imageUrl}`;
    }
    return getDefaultImage(item.id);
  };

  return (
    <>
      {config.items.map((item, index) => (
        <section key={item.id || index} className={`feature-section ${item.id}`}>
          <div className="feature-content">
            <h2 className="feature-heading">{item.title}</h2>
            <p className="feature-subtitle">{item.description}</p>
            <div className="feature-image-container">
              <img
                src={getImageSrc(item)}
                alt={item.title}
                className="feature-image"
              />
            </div>
          </div>
        </section>
      ))}
    </>
  );
}

